/**
 * @see /client/containers/RestaurantDetails/Deal.js // dependecy already removed
 * @see /client/containers/Profile/index.js
 * @see /client/containers/OrderSummary/index.js
 * @see /client/containers/PlanAParty/index.js
 * @todo: need to update the code of profile
 * @todo: make similar to @see /client/components/Checkbox/index.js
 */
import React from 'react';
import PropTypes from 'prop-types';

import RadioInput from './RadioInput';

const Radio = (props) => {
  const { id, children, isChecked, payloadKey, _onEventChange, selectedOption, ...otherProps } = props;
  return (
    <RadioInput>
      <input
        id={id}
        name="radio"
        value={id}
        // defaultChecked={isChecked}
        checked={selectedOption === id}
        type="radio"
        onChange={() => _onEventChange(payloadKey, id)}
        {...otherProps}
      />
      <label htmlFor={id}>
        {children}
      </label>
    </RadioInput>
  );
};

Radio.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  // disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  _onEventChange: PropTypes.func,
  payloadKey: PropTypes.string,
  selectedOption: PropTypes.string,
};
Radio.defaultProps = {
  // isChecked: false,
  payloadKey: 'radio',
  _onEventChange: () => '',
};
export default Radio;



// WEBPACK FOOTER //
// client/components/Radio/index.js